import { Link } from "react-router-dom";
import { GustoLogo } from "@/components/GustoLogo";
import { Smartphone, ChefHat, Store, ShieldCheck } from "lucide-react";

const footerLinks = {
  legal: [
    { label: "CGV", path: "/legal/cgv" },
    { label: "Mentions légales", path: "/legal/mentions" },
    { label: "Politique de confidentialité", path: "/legal/confidentialite" },
  ],
  help: [
    { label: "FAQ", path: "/faq" },
    { label: "Support", path: "/support" },
  ],
};

const features = {
  particulier: [
    "Scanner de tickets de caisse",
    "Création de recettes par dictée vocale",
    "Scanner de frigo / plat",
    "Repas entre amis & notation",
    "Cave à vins",
    "Budget courses & alertes",
  ],
  professionnel: [
    "Vitrine en ligne & catalogue",
    "Click & Collect",
    "Campagnes promotionnelles",
    "Gestion des commandes",
    "Statistiques & analytics",
    "Communauté locale",
  ],
};

const GustoFooter = () => (
  <footer className="bg-charcoal/95 py-10 px-4" data-testid="gusto-footer">
    <div className="max-w-5xl mx-auto">
      {/* Top row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        {/* Brand */}
        <div className="md:col-span-1">
          <GustoLogo size="sm" variant="dark" />
          <div className="flex h-3 rounded-sm overflow-hidden shadow-sm mt-3 w-8">
            <div className="w-1/3 bg-blue-500" />
            <div className="w-1/3 bg-white" />
            <div className="w-1/3 bg-red-500" />
          </div>
          <p className="text-xs text-white/50 mt-3">
            Développé par <span className="text-white/80 font-medium">BESSON SOLUTIONS</span>
          </p>
        </div>

        {/* Features - Particulier */}
        <div>
          <h4 className="flex items-center gap-1.5 text-xs font-heading font-bold text-white/80 mb-3 uppercase tracking-wider">
            <ChefHat className="w-3.5 h-3.5" /> Particulier
          </h4>
          <ul className="space-y-1.5">
            {features.particulier.map((f) => (
              <li key={f} className="text-xs text-white/40">{f}</li>
            ))}
          </ul>
        </div>

        {/* Features - Pro */}
        <div>
          <h4 className="flex items-center gap-1.5 text-xs font-heading font-bold text-white/80 mb-3 uppercase tracking-wider">
            <Store className="w-3.5 h-3.5" /> Professionnel
          </h4>
          <ul className="space-y-1.5">
            {features.professionnel.map((f) => (
              <li key={f} className="text-xs text-white/40">{f}</li>
            ))}
          </ul>
        </div>

        {/* Links */}
        <div>
          <h4 className="flex items-center gap-1.5 text-xs font-heading font-bold text-white/80 mb-3 uppercase tracking-wider">
            <ShieldCheck className="w-3.5 h-3.5" /> Légal & Aide
          </h4>
          <ul className="space-y-1.5">
            {footerLinks.legal.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-xs text-white/40 hover:text-white/70 transition-colors">{l.label}</Link>
              </li>
            ))}
            <li className="pt-2 border-t border-white/10">
              {footerLinks.help.map((l) => (
                <Link key={l.path} to={l.path} className="block text-xs text-white/40 hover:text-white/70 transition-colors mt-1.5">{l.label}</Link>
              ))}
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 pt-4 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-[10px] text-white/30">
          &copy; {new Date().getFullYear()} Gusto — Tous droits réservés
        </p>
        <div className="flex items-center gap-3">
          <Link to="/stores" className="text-[10px] text-white/30 hover:text-white/60 transition-colors">Annuaire commerces</Link>
          <span className="text-white/10">|</span>
          <Link to="/leaderboard" className="text-[10px] text-white/30 hover:text-white/60 transition-colors">Classement</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default GustoFooter;
